import { GlobalRouter } from './GlobalRouter';
import { isServer } from '@okapi/dom-utils';
const tracked = new Map();
let asyncHooks;
try {
    // @ts-ignore
    asyncHooks = require('async_hooks');
}
catch (e) {
    asyncHooks = {
        executionAsyncId() {
            return 0;
        },
        createHook() {
            return {
                enable() {
                    return this;
                },
                disable() {
                    return this;
                },
            };
        },
    };
}
if (isServer()) {
    asyncHooks
        .createHook({
        destroy: (asyncId) => {
            if (tracked.has(asyncId)) {
                tracked.delete(asyncId);
            }
        },
    })
        .enable();
}
/**
 * @deprecated
 * @param url
 */
export function getAsyncRouter(url) {
    const eid = asyncHooks.executionAsyncId();
    let router = tracked.get(eid);
    if (typeof router === 'undefined') {
        router = new GlobalRouter(url);
        tracked.set(eid, router);
    }
    return router;
}
